"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HcxCreateOrderDtoSpermCountResultEnum = exports.HcxCreateOrderDtoPrenatalDiagnosisCytoPregnancyTerminatedEnum = exports.HcxCreateOrderDtoPregnancyLossCytoNipsResultEnum = exports.HcxCreateOrderDtoExomeOptionEnum = exports.HcxCreateOrderDtoIsInternalFvtEnum = exports.HcxCreateOrderDtoCellCultureReasonForTestingEnum = exports.HcxCreateOrderDtoPrenatalDiagnosisCytoReasonForTestingEnum = exports.HcxCreateOrderDtoParentalFollowupCytoReasonForTestingEnum = exports.HcxCreateOrderDtoRecurrentPregnancyLossCytoReasonForTestingEnum = exports.HcxCreateOrderDtoPregnancyLossCytoReasonForTestingTestsEnum = exports.HcxCreateOrderDtoPregnancyLossCytoReasonForTestingEnum = exports.HcxCreateOrderDtoDiagnosticReasonForTestingEnum = exports.HcxCreateOrderDtoProactiveReasonForTestingEnum = exports.HcxCreateOrderDtoNipsReasonForTestingEnum = exports.HcxCreateOrderDtoCarrierReasonForTestingEnum = exports.HcxCreateOrderDtoDiseaseStatusEnum = exports.HcxCreateOrderDtoBreastCancerTypesEnum = exports.HcxCreateOrderDtoSolidTumorReasonForTestingEnum = void 0;
exports.HcxCreateOrderDtoSolidTumorReasonForTestingEnum = {
    BreastCancer: 'breast_cancer',
    ColorectalCancer: 'colorectal_cancer',
    Melanoma: 'melanoma',
    Nsclc: 'nsclc',
    ProstateCancer: 'prostate_cancer',
    OvarianCancer: 'ovarian_cancer',
    Other: 'other'
};
exports.HcxCreateOrderDtoBreastCancerTypesEnum = {
    HormoneReceptorPositive: 'breast_cancer_hormone_receptor_positive',
    Her2Positive: 'breast_cancer_her2_positive',
    TripleNegative: 'breast_cancer_triple_negative'
};
exports.HcxCreateOrderDtoDiseaseStatusEnum = {
    LocalizedPrimary: 'disease_status_localized_primary',
    LocallyAdvanced: 'disease_status_locally_advanced',
    Metastatic: 'disease_status_metastatic',
    RecurrentLocal: 'disease_status_recurrent_local',
    RecurrentDistant: 'disease_status_recurrent_distant',
    Refractory: 'disease_status_refractory',
    Diagnostic: 'disease_status_diagnostic',
    Remission: 'disease_status_remission',
    Relapse: 'disease_status_relapse',
    Other: 'disease_status_other'
};
exports.HcxCreateOrderDtoCarrierReasonForTestingEnum = {
    IsCarrierScreening: 'is_carrier_screening',
    IsPatientOrPartnerPregnant: 'is_patient_or_partner_pregnant',
    IsPartnerKnownCarrier: 'is_partner_known_carrier',
    PartnerTestedAtInvitae: 'partner_tested_at_invitae',
    PositiveFamilyHistory: 'positive_family_history',
    IsGameteDonor: 'is_gamete_donor',
    IsOtherIndicationReason: 'is_other_indication_reason'
};
exports.HcxCreateOrderDtoNipsReasonForTestingEnum = {
    AverageRiskPregnancy: 'is_average_risk_pregnancy',
    AdvancedMaternalAge: 'is_advanced_maternal_age',
    PositiveSerumScreen: 'is_positive_serum_screen',
    AbnormalUltrasound: 'is_abnormal_ultrasound',
    HistorySuggestiveOfIncreasedRisk: 'is_history_suggestive_of_increased_risk',
    OtherReason: 'is_other_reason',
    SupervisionOfNormalPregnancy: 'is_supervision_of_normal_pregnancy',
    HistoryOfChromosomalDisorder: 'is_history_of_chromosomal_disorder'
};
exports.HcxCreateOrderDtoProactiveReasonForTestingEnum = {
    IsHealthyPatient: 'is_healthy_patient',
    HasRelatedSymptoms: 'has_related_symptoms',
    HasProactiveFamilyHistory: 'has_proactive_family_history',
    HasRelatedGeneticResults: 'has_related_genetic_results',
    HasOtherProactiveReason: 'has_other_proactive_reason'
};
exports.HcxCreateOrderDtoDiagnosticReasonForTestingEnum = {
    HasDiagnosticIndividualHistory: 'has_diagnostic_individual_history',
    HasDiagnosticFamilyHistory: 'has_diagnostic_family_history',
    HasPreviousResults: 'has_previous_results',
    HasOtherDiagnosticReason: 'has_other_diagnostic_reason',
    IsKnownFamilyVariant: 'is_known_family_variant',
    IsProbandAdopted: 'is_proband_adopted',
    IsLimitedFamilyStructure: 'is_limited_family_structure'
};
exports.HcxCreateOrderDtoPregnancyLossCytoReasonForTestingEnum = {
    IsRecurrent: 'is_recurrent',
    IsTherapeuticAbortion: 'is_therapeutic_abortion',
    IsStillbirth: 'is_stillbirth',
    IsFetalDemise: 'is_fetal_demise',
    IsMissedAbortion: 'is_missed_abortion',
    IsMiscarriage: 'is_miscarriage',
    IsMolarPregnancy: 'is_molar_pregnancy',
    IsChromosomalAbnormalities: 'is_chromosomal_abnormalities',
    HasOtherPregnancyLossCytoReason: 'has_other_pregnancy_loss_cyto_reason'
};
exports.HcxCreateOrderDtoPregnancyLossCytoReasonForTestingTestsEnum = {
    HasFetalKaryotype: 'has_fetal_karyotype',
    HasPgta: 'has_pgta',
    HasNips: 'has_nips',
    IsHistopathology: 'is_histopathology'
};
exports.HcxCreateOrderDtoRecurrentPregnancyLossCytoReasonForTestingEnum = {
    FemaleInfertility: 'is_female_infertility',
    RecurrentPregnancyLoss: 'is_recurrent_pregnancy_loss',
    MaleInfertility: 'is_male_infertility',
    MalePartnerRecurrentPregnancyLoss: 'is_male_partner_recurrent_pregnancy_loss',
    OtherIndicationReason: 'is_other_indication_reason',
    SuspectedChromosomeAbnormality: 'is_suspected_chromosome_abnormality'
};
exports.HcxCreateOrderDtoParentalFollowupCytoReasonForTestingEnum = {
    WasPreviousTestingPerformedAtInvitae: 'was_previous_testing_performed_at_invitae'
};
exports.HcxCreateOrderDtoPrenatalDiagnosisCytoReasonForTestingEnum = {
    AdvancedMaternalAge: 'is_advanced_maternal_age',
    PositiveSerumScreen: 'is_positive_serum_screen',
    AbnormalUltrasound: 'is_abnormal_ultrasound',
    HistorySuggestsRisk: 'is_history_suggests_risk',
    OtherIndicationReason: 'is_other_indication_reason'
};
exports.HcxCreateOrderDtoCellCultureReasonForTestingEnum = {
    IsOtherIndicationReason: 'is_other_indication_reason'
};
exports.HcxCreateOrderDtoIsInternalFvtEnum = {
    Yes: 'yes',
    No: 'no'
};
exports.HcxCreateOrderDtoExomeOptionEnum = {
    ProbandOnly: 'probandOnly',
    Duo: 'duo',
    Trio: 'trio'
};
exports.HcxCreateOrderDtoPregnancyLossCytoNipsResultEnum = {
    NegativeNoAbnormalitiesDetected: 'Negative: No abnormalities detected',
    Trisomy21: 'Trisomy 21',
    Trisomy18: 'Trisomy 18',
    Trisomy13: 'Trisomy 13',
    MonosomyX: 'Monosomy X',
    Xxx: 'XXX',
    Xxy: 'XXY',
    Xyy: 'XYY',
    _1p36Deletion: '1p36 deletion',
    _4p163DeletionWolfHirschhorn: '4p16.3 deletion (Wolf-Hirschhorn)',
    _5p152DeletionCriDuChat: '5p15.2 deletion (Cri du Chat)',
    _15p112DeletionPwsAs: '15p11.2 deletion (PWS/AS)',
    _22q112DeletionDiGeorge: '22q11.2 deletion (DiGeorge)',
    Triploidy: 'Triploidy',
    NoResult: 'No result',
    Other: 'Other'
};
exports.HcxCreateOrderDtoPrenatalDiagnosisCytoPregnancyTerminatedEnum = {
    SabIufd: 'SAB/IUFD',
    Tab: 'TAB',
    Empty: ''
};
exports.HcxCreateOrderDtoSpermCountResultEnum = {
    Normal: 'Normal',
    ResultsPending: 'Results pending',
    AzoospermiaNonObstructive: 'Azoospermia: non-obstructive',
    AzoospermiaObstructive: 'Azoospermia: obstructive',
    AzoospermiaUnknown: 'Azoospermia: unknown',
    Abnormal: 'Abnormal',
    Other: 'Other'
};
